const TextBodyStyleProvider = require('./TextBodyStyleProvider');
const ShapeStyleProvider = require('./ShapeStyleProvider');

module.exports = {
    loadTextBodyDefaults: TextBodyStyleProvider.loadTextBodyDefaults,
    TextBody: TextBodyStyleProvider.getStyleProviderForClass,
    Shape: ShapeStyleProvider
};
